import { offset, flip } from '@floating-ui/dom'
export const officePersonnelSteps = (tourInstance, stepCallback) => {
  return [
    {
      text: 'Welcome to Office Management.  You can use this section to view and edit information about your office(s) and office staff, as well as create new users and deactivate former team members',
      buttons: [
        {
          text: 'Next',
          action: tourInstance.next,
        },
      ],
    },
    {
      attachTo: { element: '[data-tour-tabs]', on: 'top' },
      text: 'Use these tabs at the top to switch between different views.  Profile is where you can view and edit information about yourself.  The Office tab is where you can manage office staff and information about your office.',
      scrollTo: { behavior: 'smooth', block: 'nearest' },
      buttons: [
        {
          text: 'Back',
          action: tourInstance.back,
        },
        {
          text: 'Next',
          action: tourInstance.next,
        },
      ],
    },
    {
      attachTo: { element: '[data-tour-office-data]', on: 'right' },
      floatingUIOptions: {
        middleware: [flip(), offset(20)],
      },
      modalOverlayOpeningPadding: 10,
      when: {
        'before-show': () => {
          stepCallback('open-office-tab')
        },
      },
      beforeShowPromise: () => {
        return new Promise(function (resolve) {
          stepCallback('open-office-tab').then(() => {
            resolve()
          })
        })
      },
      text: 'For compliance purposes, none of the information is editable in this top section.  Please submit a ticket to Motto product Support if you need to change any of this information',
      buttons: [
        {
          text: 'Back',
          action: tourInstance.back,
        },
        {
          text: 'Next',
          action: tourInstance.next,
        },
      ],
    },
    {
      floatingUIOptions: {
        middleware: [flip(), offset(20)],
      },
      modalOverlayOpeningPadding: 10,
      attachTo: { element: '[data-tour-office-graph]', on: 'left' },
      text: 'The production graph is updated when the leaderboard is released each month.  Hover over each bar in the graph to see the volume and units the LO has produced in the calendar year.  Only Phase 2 LOs with production will display on the graph.  YTD Office displays your aggregate production for the year in this office.  Clicking on a user portrait in the Production graph will open their profile to view.',
      buttons: [
        {
          text: 'Back',
          action: tourInstance.back,
        },
        {
          text: 'Next',
          action: tourInstance.next,
        },
      ],
    },
    {
      id: 'request-new-state-licenses',
      attachTo: { element: '[data-tour-office-request-license]', on: 'left' },
      floatingUIOptions: {
        middleware: [flip(), offset(12)],
      },
      modalOverlayOpeningPadding: 0,
      modalOverlayOpeningRadius: 25,
      text: 'Request new State Licenses, up to three plus D.C., for your office.  You can additionally request that LO Phase 2 staff members receive the same State License when requesting an office State License.  You will receive a notification when it has been approved by Product Support.',
      buttons: [
        {
          text: 'Back',
          action: tourInstance.back,
        },
        {
          text: 'Next',
          action: tourInstance.next,
        },
      ],
      showOn: () => {
        return document.querySelector('[data-tour-office-request-license]')
      },
    },
    {
      attachTo: { element: '[data-tour-office-website]', on: 'left' },
      floatingUIOptions: {
        middleware: [flip(), offset(20)],
      },
      modalOverlayOpeningPadding: 10,
      text: 'Here you can view information about your published website.  Note that you cannot view or edit website information until your website has been activated.',
      buttons: [
        {
          text: 'Back',
          action: tourInstance.back,
        },
        {
          text: 'Next',
          action: tourInstance.next,
        },
      ],
      beforeShowPromise: () => {
        return new Promise(function (resolve) {
          stepCallback('open-office-website-section').then(() => {
            resolve()
          })
        })
      },
    },
    {
      attachTo: { element: '[data-tour-add-new-user]', on: 'left' },
      text: 'You can add new team members to your office by clicking the Add New User button.  After entering some required information about the team member and hitting submit, the new user will receive an activation email at their designated Personal Email.',
      floatingUIOptions: {
        middleware: [flip(), offset(12)],
      },
      modalOverlayOpeningPadding: 0,
      modalOverlayOpeningRadius: 25,
      buttons: [
        {
          text: 'Back',
          action: tourInstance.back,
        },
        {
          text: 'Next',
          action: tourInstance.next,
        },
      ],
    },
    {
      attachTo: { element: '[data-tour-user-roster-pill]', on: 'left' },
      text:
        'Here you can view and manage profiles of your office staff. <br> <br>' +
        '<b>View Profile</b>:  User profiles can be viewed.  This will open a new tab at the top of the screen.' +
        '  Middle click to open multiple profiles without switching tabs. <br> <br>' +
        '<b>Update Role</b>: User Roles can be added or removed, such as adding a Marketing Specialist role or' +
        ' requesting' +
        ' Phase 2 access for a licensed Loan Originator. <br> <br>' +
        '<b>Deactivate</b>: Deactivate team members.  During deactivation you can request Email Access to that team' +
        " member's O365 account for 30 days.",
      modalOverlayOpeningRadius: 18,
      buttons: [
        {
          text: 'Back',
          action: tourInstance.back,
        },
        {
          text: 'Next',
          action: tourInstance.next,
        },
      ],
    },
    {
      attachTo: { element: '[data-tour-help-button]', on: 'left' },
      floatingUIOptions: {
        middleware: [flip(), offset(15)],
      },
      modalOverlayOpeningPadding: 2,
      text: 'If you need assistance updating any information that is not editable on these pages, submit a ticket to Motto Product Support',
      buttons: [
        {
          text: 'Back',
          action: tourInstance.back,
        },
        {
          text: 'Next',
          action: tourInstance.next,
        },
      ],
    },
    {
      text:
        'This concludes the Office Management tutorial!  You can download the full user guide by <a' +
        ' target="_blank" href="https://www.mottocenter.com/resource/1310">clicking' +
        ' this' +
        ' link.</a>',
      buttons: [
        {
          text: 'Back',
          action: tourInstance.back,
        },
        {
          text: 'Done',
          action: tourInstance.complete,
        },
      ],
    },
  ]
}
